export default __webpack_public_path__ + "static/media/bathroom1-before-1024w.7c144b4f.webp";